"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var EnvironmentHelper = exports.default = /*#__PURE__*/function () {
  function EnvironmentHelper() {
    (0, _classCallCheck2.default)(this, EnvironmentHelper);
  }
  return (0, _createClass2.default)(EnvironmentHelper, null, [{
    key: "hostNameIncludes",
    value: function hostNameIncludes(subDomains) {
      return !!subDomains.find(function (subDom) {
        return (window.location.hostname || '').toLowerCase().startsWith(subDom);
      });
    }
  }, {
    key: "isPQAStage",
    value: function isPQAStage() {
      return EnvironmentHelper.hostNameIncludes(['pqa']);
    }
  }, {
    key: "isUATStage",
    value: function isUATStage() {
      return EnvironmentHelper.hostNameIncludes(['uat', 'uat-portal']);
    }
  }, {
    key: "isLQAStage",
    value: function isLQAStage() {
      return EnvironmentHelper.hostNameIncludes(['lqa', 'dev-www', 'dev-portal']);
    }
  }, {
    key: "isProdStage",
    value: function isProdStage() {
      return EnvironmentHelper.hostNameIncludes(['www', 'portal']);
    }
  }, {
    key: "getAemInstanceKey",
    value: function getAemInstanceKey() {
      if (EnvironmentHelper.isPQAStage()) {
        return 'PQA';
      }
      if (EnvironmentHelper.isProdStage()) {
        return 'PROD';
      }
      if (EnvironmentHelper.isUATStage()) {
        return 'UAT';
      }
      if (EnvironmentHelper.isLQAStage()) {
        return 'LQA';
      }
      return undefined;
    }
  }]);
}();